import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RecruitmentOfferService } from '../../../core/services/recruitment-offer.service';
import { RecruitmentApplicationService } from '../../../core/services/recruitment-application.service';
import { LoadingComponent } from '../../components/loading/loading.component';

@Component({
  selector: 'app-recruitment-detail',
  templateUrl: './recruitment-detail.component.html',
  imports: [CommonModule, FormsModule, RouterModule, LoadingComponent]
})
export class RecruitmentDetailComponent {
  offerId: any;
  offer: any = null;
  loading = false;
  notFound = false;

  submitting = false;
  submitted = false;
  errorMessage = '';

  cvFile: File | null = null;

  form: any = this.emptyForm();

  readonly EDUCATION_LEVELS = ['BEPC', 'BAC', 'BAC+2', 'BAC+3 (Licence)', 'BAC+5 (Master)', 'Doctorat', 'Autre'];

  constructor(
    private route: ActivatedRoute,
    private offerService: RecruitmentOfferService,
    private applicationService: RecruitmentApplicationService
  ) {}

  ngOnInit(): void {
    this.offerId = this.route.snapshot.paramMap.get('id');
    this.getOffer();
  }

  emptyForm() {
    return {
      firstname: '', lastname: '', email: '', phone: '',
      education_level: '', years_experience: 0, cover_letter: ''
    };
  }

  getOffer() {
    this.loading = true;
    this.notFound = false;
    this.offerService.publicGet(this.offerId).subscribe((res: any) => {
      this.loading = false;
      this.offer = res.data ?? null;
      if (!this.offer) this.notFound = true;
    }, () => { this.loading = false; this.notFound = true; });
  }

  onFileSelected(ev: any) {
    if (ev.target.files && ev.target.files.length > 0) {
      this.cvFile = ev.target.files[0];
    }
  }

  submit() {
    this.errorMessage = '';
    if (!this.cvFile) {
      this.errorMessage = 'Veuillez joindre votre CV.';
      return;
    }
    this.submitting = true;

    const fd = new FormData();
    fd.append('recruitment_offer_id', this.offerId);
    fd.append('firstname', this.form.firstname);
    fd.append('lastname', this.form.lastname);
    fd.append('email', this.form.email);
    fd.append('phone', this.form.phone ?? '');
    fd.append('cover_letter', this.form.cover_letter ?? '');
    fd.append('years_experience', String(this.form.years_experience ?? 0));
    fd.append('education_level', this.form.education_level ?? '');
    fd.append('cv_file', this.cvFile);

    this.applicationService.apply(fd).subscribe((res: any) => {
      this.submitting = false;
      this.submitted = true;
    }, (err: any) => {
      this.submitting = false;
      this.errorMessage = err?.error?.message || 'Une erreur est survenue lors de l\'envoi de votre candidature. Veuillez réessayer.';
    });
  }
}
